import { useEffect, useState } from 'react'
import { streamCallRecording } from '@services/api/calls.api'
import { recordingBlobNameFromRef } from '@utils/call-recording-playback.util'

export const useCallRecordingObjectUrl = (
  recordingRef?: string | null,
): string => {
  const [src, setSrc] = useState('')

  useEffect(() => {
    let objectUrl = ''
    let cancelled = false

    if (recordingRef?.startsWith('blob:')) {
      setSrc(recordingRef)
      return () => undefined
    }

    const blobName = recordingBlobNameFromRef(recordingRef)

    if (!blobName) {
      const http =
        recordingRef &&
        /^https?:\/\//i.test(recordingRef) &&
        !recordingRef.includes('/recordings/stream')
          ? recordingRef
          : ''
      setSrc(http)
      return () => undefined
    }

    setSrc('')
    void streamCallRecording(blobName)
      .then((url) => {
        if (cancelled) {
          URL.revokeObjectURL(url)
          return
        }
        objectUrl = url
        setSrc(url)
      })
      .catch(() => {
        if (!cancelled) setSrc('')
      })

    return () => {
      cancelled = true
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [recordingRef])

  return src
}
